export default [
  {
    value: 'account',
    text: 'Покупатель',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'displayName',
    text: 'Название события',
    type: 'string',
    description: ''
  },
  {
    value: 'price',
    text: 'Цена',
    width: 120,
    align: 'end',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 240,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Время оплаты',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 60,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
